<script setup>
</script>

<template>
  <h2 class="cloud-calculator__title">
    {{ $Bitrix.Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_TITLE') }}
  </h2>
</template>
